import React from 'react';
import { Badge } from '@sinohealth/butterfly-ui-components/lib';
import { useNavigate } from 'react-router-dom';
import style from './index.less';
import msgIcon from '@/assets/images/messagePage/msgIcon.svg';
import { useMsg } from '@/hooks/useUnreadMsg';

const { NODE_ENV } = process.env;
type OrderFormProps = {
  // unreas: any;
  ifOpMsgCount?: () => void;
};
/**
 * 消息
 * @returns
 */
// export const mgsCont = createContext(0);
const messagePage: React.FC<OrderFormProps> = (props) => {
  const navigate = useNavigate();
  const [unreadMsg] = useMsg(true);
  const opMsgCount = () => {
    navigate('/message/applyMessage');
  };

  return (
    <>
      <span className={`${style['msg-box']}`} onClick={opMsgCount}>
        {/* <Badge count={msgCount}> */}
        <Badge count={unreadMsg.applyUnreadCount + unreadMsg.sysUnreadCount || 0}>
          <img src={msgIcon} className={`${style['msg-icon']}`} />
        </Badge>
      </span>
      {/* <a href="#" onClick={pushMessageFun}>
        <span>测试消息推送</span>
      </a> */}
    </>
  );
};
export default messagePage;
